import {
    Form, FormButton, FormButtonContainer, FormErrors, FormItem, FormSubmitHandler, MaskedInput, TextInput, useAlerts, useForm,
} from "@sis/react-library"
import { ExampleDto } from "./FormSamplesErrorsPage";

/////////////////////////////////////////////////////////////////////////////////////////////
// You can add your own custom errors, the form below won't submit
// unless a tel or email is given.
/////////////////////////////////////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////////////////////////////////////
// Interface for the form (see basic usage example for more information).
/////////////////////////////////////////////////////////////////////////////////////////////
// allow no members for shorter name to be more readable below
// eslint-disable-next-line
interface T extends ExampleDto { }

interface FormSamplesErrorsFormProps {
    onSubmit: FormSubmitHandler<ExampleDto>;
    submitting: boolean;
}

export const FormSamplesErrorsForm = ({
    onSubmit, submitting
}: FormSamplesErrorsFormProps) => {

    const formName = 'FormErrors';

    const { getItem, setError, resetForm } = useForm<T>(formName);
    const { confirm } = useAlerts();

    const handleCancel = () => {
        confirm('Cancel', 'Are you sure you want to cancel and loose your changes?',
            () => { resetForm() },
            "Yes", "No"
        );
    }

    const handleItemChange = () => {
        const phoneNumberField = getItem('phoneNumber');
        const emailField = getItem('email');

        const hasPhoneNumber = phoneNumberField.value !== undefined && phoneNumberField.value !== '';
        const hasEmail = emailField.value !== undefined && emailField.value !== '';

        const valid = hasPhoneNumber || hasEmail;

        setError("emailOrPhoneNumber", !valid, "Please enter either an email or phone number!", ["email", "phoneNumber"]);
    }

    return (
        <Form<T>
            name={formName}
            onSubmit={onSubmit}
            submitting={submitting}
            beforeLeaveText='You have made changes, are you sure you want to leave ?'
        >
            <FormItem<T>
                formField="name"
                label="Name"
                onItemChange={handleItemChange}
                rules={[{ type: "required", message: "Please enter your name!" }]}
                element={<TextInput maxLength={20} />}
            />
            <FormItem<T>
                formField="phoneNumber"
                label="Phone Number"
                onItemChange={handleItemChange}
                element={<MaskedInput maskedType="PhoneNumber" />}                
            />
            <FormItem<T>
                formField="email"
                label="Email"
                onItemChange={handleItemChange}
                rules={[{ type: "email", message: "Invalid email address!" }]}
                element={<TextInput maxLength={50} />}
            />
            <FormButtonContainer>
                <FormButton
                    formButtonText='Cancel'
                    onClick={() => { handleCancel() }}
                />
                <FormButton
                    formButtonText='Submit'
                    // In this example we always want the submit button to be enabled, as the user won't know right 
                    // away that a phone number or email address is selected, and nothing is highlighted
                    // to do that we are setting the alwaysEnabled prop
                    alwaysEnabled
                    submitButton
                />
            </FormButtonContainer>
            <FormErrors forFormErrors
                //generalMessage="The following errors occured:"  // Uncomment for a general message displayed before the items
                //showFieldValidationErrors  // Uncomment if you wish to show field validation errors as well
                //includeFieldLabels  // If showing field validation errors (above), uncomment to include field labels
                displayOnSubmitOnly  // Remove if you want the error to show before the form is submitted
            />
        </Form>
    )
}
